import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Function to scroll to top
    const scrollToTopFunction = () => {
      // Scroll window to top
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
      
      // Also scroll document element and body
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      // Scroll any main content containers
      const mainContent = document.querySelector('main');
      if (mainContent) {
        mainContent.scrollTop = 0;
      }
      
      // Scroll any wrapper divs
      const wrapper = document.querySelector('.main__content_wrapper');
      if (wrapper) {
        wrapper.scrollTop = 0;
      }
    };
    
    // Scroll immediately
    scrollToTopFunction();
    
    // Scroll again after a small delay (for DOM update)
    const timer1 = setTimeout(scrollToTopFunction, 50);
    
    // Scroll again after a longer delay (for content load)
    const timer2 = setTimeout(scrollToTopFunction, 200);
    
    // Use requestAnimationFrame for smoother execution
    const rafId = requestAnimationFrame(() => {
      scrollToTopFunction();
    });
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      cancelAnimationFrame(rafId);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;